import { Component, Input, OnInit, Output,EventEmitter,ViewChild, AfterViewInit } from '@angular/core';
import { GeneralService } from '../services/general.service';
declare var $: any;
declare var FullCalendar: any;
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit ,AfterViewInit
{
  @Input() code;
  @Input() events;
  @Input() intervale:number;
  @Input() defaultDate :Date = new Date();
  @Input() date_Debut :Date;
  @Input() date_Fin :Date;
  @Input() showHeader : boolean = true;
  @Input() selectable : boolean = false;
  @Input() editable : boolean = false;
  @Input() weekends : boolean = true;
  @Input() paramHeure;
  @Input() htmlTitre : boolean = false;
  @Output() actionCalendar: EventEmitter<any> = new EventEmitter<any>();
  header;
  selectedDate = [];
  selectedEvent;
  view: string = 'week';
  defaultView="dayGridMonth";
  compteur : number = 0;
  validRange;
  calendarComponent

  constructor(public generalService: GeneralService) {
    
   }

  ngOnInit() 
  {
    if(!this.paramHeure)
      this.paramHeure = {avtHeureAM_Deb:"07:00",avtHeureAM_Fin:"",avtHeurePM_Deb:"",avtHeurePM_Fin:"24:00",avtHeure_Ecart:"60"}
    this.setDefaultViewCalandar();
  }
  ngAfterViewInit()
  {
      this.initCalendar();
  }
  setDefaultViewCalandar()
  {
    switch(this.intervale) 
    {
      case 1:
        this.defaultView="timeGridDay";
        break;
      case 7:
        this.defaultView="timeGridWeek";
        break;
      case 30:
        this.defaultView="dayGridMonth";
        break;
    } 
  }
  initCalendar()
  {
    if(this.showHeader)
      this.header = 
      {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,dayGridWeek,dayGridDay,listWeek'
      }
      else
        this.header = 
        {
          left: '',
          center: '',
          right: ''
        }

        
    var calendarEl = document.getElementById('calendar' + this.code);
    this.calendarComponent = new FullCalendar.Calendar(calendarEl, 
    {
      headerToolbar: this.header,
      initialDate: this.setToFormatDateServerStr(this.defaultDate),
      navLinks: false, // can click day/week names to navigate views
      businessHours: false, // display business hours
      editable: this.editable,
      selectable: this.selectable,
      locale: 'fr',
      selectLongPressDelay : 500,
      events: this.events,
      initialView : this.defaultView,
      slotDuration:"00:"+this.paramHeure.avtHeure_Ecart+":00",
      slotMinTime: this.paramHeure.avtHeureAM_Deb+":00",
      slotMaxTime: this.paramHeure.avtHeurePM_Fin+":00",
      dayHeaderFormat:{ weekday: 'short', month: 'numeric', day: 'numeric', omitCommas: true },
      validRange: ((this.date_Debut != undefined && this.date_Fin != undefined)? ({start: this.setToFormatDateServerStr(this.date_Debut), end:  this.setToFormatDateServerStr(this.date_Fin)}) : this.validRange),
      weekends: this.weekends,
      unselectAuto : false,
      unselectCancel  : false,
      allDaySlot: false,
      weekNumbers : true,
      select : (event)=>
      {
        this.actionCalendar.emit({event:event,acton:"select",calendarComponent :  this.calendarComponent,code : this.code});
      },
      eventClick : (event)=>
      {
        console.log(event);
        
        this.actionCalendar.emit({event:event,acton:"eventClick",calendarComponent :  this.calendarComponent,code : this.code});
      },
      dateClick : (event)=>
      {
        this.actionCalendar.emit({event:event,acton:"dateClick",calendarComponent :  this.calendarComponent,code : this.code});
      },

      selectDate : (event)=>
      {
        this.actionCalendar.emit({event:event,acton:"selectDate",calendarComponent :  this.calendarComponent, code : this.code});
      },
      dayRender : (event)=>
      { 
        this.actionCalendar.emit({event:event,acton:"dayRender",calendarComponent :  this.calendarComponent, code : this.code});
      },
      eventDragStart : (event)=>
      {
        this.actionCalendar.emit({event:event,acton:"eventDragStart",calendarComponent :  this.calendarComponent, code : this.code});
      },
      eventDragStop : (event)=>
      {
        this.actionCalendar.emit({event:event,acton:"eventDragStop",calendarComponent :  this.calendarComponent, code : this.code});
      },
      eventResize : (event)=>
      {
        this.actionCalendar.emit({event:event,acton:"eventResize",calendarComponent :  this.calendarComponent, code : this.code});
      },
      eventResizeStart : (event)=>
      {
        this.actionCalendar.emit({event:event,acton:"eventResizeStart",calendarComponent :  this.calendarComponent, code : this.code});
      },
      eventRender : (event)=>
      {
        this.actionCalendar.emit({event:event,acton:"eventRender",calendarComponent :  this.calendarComponent, code : this.code});
      },
      drop : (event)=>
      {
        this.actionCalendar.emit({event:event,acton:"drop",calendarComponent :  this.calendarComponent, code : this.code});
      },
      eventMouseEnter : (event)=>
      {
        this.actionCalendar.emit({event:event,acton:"eventMouseEnter",calendarComponent :  this.calendarComponent, code : this.code});
      },
      eventMouseLeave : (event)=>
      {
        this.actionCalendar.emit({event:event,acton:"eventMouseLeave",calendarComponent :  this.calendarComponent, code : this.code});
      },
      eventContent: this.htmlTitre? (event) =>
      {
        return {
          html: [event.event.title]
        }
        
      } : ()=>{},
    });

    this.calendarComponent.render();
  }

  setEventCalandar(listeEvent)
  {
    this.calendarComponent.removeAllEvents();
    listeEvent.forEach(event => 
    {
      this.calendarComponent.addEvent(event);
    });
    // $('#calendar' + this.code).fullCalendar('removeEvents');
  }
   setDefaulDate(date?)
   {
     if(date != null && date != undefined)
     this.calendarComponent.gotoDate(date)
     else
     this.calendarComponent.gotoDate(this.defaultDate)
   }
   setOption(name,value)
   {
     this.calendarComponent.setOption(name,value)
   }
   changeView(view)
   {
     this.calendarComponent.changeView(view)
   }















  setFormatDate(date)
  {
      date = new Date(date);
      var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
      return date.toLocaleDateString("fr-FR", options);         
  }
  
  setToFormatDateServerStr(date:Date):string
  {        
      var date2 = this.setFormatDate(date);
      var tab = date2.split("/");
      return tab[2]+"-"+tab[1]+"-"+tab[0];
  }
}
